export const LOCATION_CHIPS_LIMIT = 10;
export const TOOLTIP_LIST_LIMIT = 20;

export const STATE_MAP: { [key: string]: string } = {
  Alabama: 'AL',
  AL: 'AL',
  Alaska: 'AK',
  AK: 'AK',
  Arizona: 'AZ',
  AZ: 'AZ',
  Arkansas: 'AR',
  AR: 'AR',
  California: 'CA',
  CA: 'CA',
  Colorado: 'CO',
  CO: 'CO',
  Columbia: 'DC',
  Connecticut: 'CT',
  CT: 'CT',
  Delaware: 'DE',
  DE: 'DE',
  'District of Columbia': 'DC',
  DC: 'DC',
  Florida: 'FL',
  FL: 'FL',
  Georgia: 'GA',
  GA: 'GA',
  Hawaii: 'HI',
  HI: 'HI',
  Idaho: 'ID',
  ID: 'ID',
  Illinois: 'IL',
  IL: 'IL',
  Indiana: 'IN',
  IN: 'IN',
  Iowa: 'IA',
  IA: 'IA',
  Kansas: 'KS',
  KS: 'KS',
  Kentucky: 'KY',
  KY: 'KY',
  Louisiana: 'LA',
  LA: 'LA',
  Maine: 'ME',
  ME: 'ME',
  Maryland: 'MD',
  MD: 'MD',
  Massachusetts: 'MA',
  MA: 'MA',
  Michigan: 'MI',
  MI: 'MI',
  Minnesota: 'MN',
  MN: 'MN',
  Mississippi: 'MS',
  MS: 'MS',
  Missouri: 'MO',
  MO: 'MO',
  Montana: 'MT',
  MT: 'MT',
  Nebraska: 'NE',
  NE: 'NE',
  Nevada: 'NV',
  NV: 'NV',
  'New Hampshire': 'NH',
  NH: 'NH',
  'New Jersey': 'NJ',
  NJ: 'NJ',
  'New Mexico': 'NM',
  NM: 'NM',
  'New York': 'NY',
  NY: 'NY',
  'North Carolina': 'NC',
  NC: 'NC',
  'North Dakota': 'ND',
  ND: 'ND',
  Ohio: 'OH',
  OH: 'OH',
  Oklahoma: 'OK',
  OK: 'OK',
  Oregon: 'OR',
  OR: 'OR',
  Pennsylvania: 'PA',
  PA: 'PA',
  'Rhode Island': 'RI',
  RI: 'RI',
  'South Carolina': 'SC',
  SC: 'SC',
  'South Dakota': 'SD',
  SD: 'SD',
  Tennessee: 'TN',
  TN: 'TN',
  Texas: 'TX',
  TX: 'TX',
  Utah: 'UT',
  UT: 'UT',
  Vermont: 'VT',
  VT: 'VT',
  Virginia: 'VA',
  VA: 'VA',
  Washington: 'WA',
  WA: 'WA',
  'West Virginia': 'WV',
  WV: 'WV',
  Wisconsin: 'WI',
  WI: 'WI',
  Wyoming: 'WY',
  WY: 'WY',
};

export const ZIP_REGEX = /^\d{5}$/;
export const ZIP_CODES_REGEX = /^((\d{5})((\s+|\s*,\s*)\d{5})*)+,?$/;
export const STATES_REGEX = new RegExp(`\\b(${Object.keys(STATE_MAP).join('|')})\\b`, 'i');
